import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
const EXPAND_ICON = `
<svg height="24" viewBox="0 -960 960 960" width="24" id="expand_more"><path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/></svg>
`;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-filter-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatTooltipModule,
  ],
  templateUrl: './filter-header.component.html',
  styleUrls: ['./filter-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterHeaderComponent implements OnDestroy {
  @Input() countActiveFilters = 0;
  @Input() filterName = 'filter';
  @Output() openFilter = new EventEmitter<boolean>(false);

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral(
      'attach_file',
      sanitizer.bypassSecurityTrustHtml(EXPAND_ICON)
    );
  }

  ngOnDestroy(): void {
    this.countActiveFilters = 0;
  }

  open() {
    this.openFilter.emit(true);
  }
}
